import type { MaintenanceWindow } from '$lib/types/maintenanceWindow';
import type { components } from '../../api-types';

export function toApiMaintenanceWindow(
  maintenanceWindow: MaintenanceWindow
): components['schemas']['ManifestMaintenanceWindow'] {
  return {
    startTime: maintenanceWindow.startTime,
    endTime: maintenanceWindow.endTime,
    zoneId: maintenanceWindow.zoneId,
    weekdays: maintenanceWindow.weekDays.map((day) => day)
  };
}
